<template>
    <div class="order-container">
        <div @click="closeHandle" class="close-btn">
            <img  src="https://staticweb.ewan.cn/resources/img/ddj-tw/yuyue-close.png" alt="">
        </div>
        <div class="order-main">
            <div class="order-title">
                <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/yuyue_title.png" alt="">
            </div>
            <div class="select-platform">
                <div class="platform" v-for="(item,index) in typeList" :key="index" @click="changeType(item.type)">
                    <div :class="['order-checkbox', currType == item.type ? 'active' : '']"></div>{{item.name}}
                    </div>
            </div>
            <div class="order-bottom">
               <div class="order-content">
                    <img class="left-pic" src="https://staticweb.ewan.cn/resources/img/ddj-tw/yuyue-girl1.png" alt="">
                    <div class="order-form">
                        <div class="phone">
                            <div :class="['area',{'down': isDown}]">
                                <span class="text" @click="toggleArea">
                                    <span v-if="!seletedArea"><span>區域</span> <i class="arrow"></i></span>
                                    <span v-else class="seleted-area">{{seletedArea.number}}</span>
                                </span>
                                <ul >
                                    <li @click="selectArea(item)" v-for="(item,index) in areaNum" :key="index">{{item.number}}</li>
                                </ul>
                            </div>
                            <input type="number" placeholder="請輸入手機號碼" v-model="phone">
                        </div>
                        <input class="email" type="text" v-model="email" placeholder="請輸入常用郵箱">
                        <div class="submit" @click="commit">提交信息</div>
                    </div>
                    <img class="right-pic" src="https://staticweb.ewan.cn/resources/img/ddj-tw/yuyue-girl2.png" alt="">
               </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            currType:1,
            typeList:[
                {type:1,name:"IOS"},
                {type:2,name:"Android"}
                ],
            phone:"", //手機
            email:"", //邮箱
            seletedArea: '', //区域编码
            isDown: false,
            areaNum: [
                {
                    number: 'HK +852',
                    length: 8 //号码长度
                },
                {
                    number: 'TW +886',
                    length: 10 //号码长度
                }
            ],
        }
    },
    methods:{
        changeType(type){
            this.currType = type
        },
        closeHandle() {
            this.$emit('close')
        },
        toggleArea(){
            this.isDown = !this.isDown;
        },
        selectArea(item){
            this.seletedArea = item;
            this.isDown = false;
        },
        commit(){
            let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
            if(!this.seletedArea){
                alert('沒有選擇區域编碼！')
            }else if(!this.phone){
                alert('沒有輸入手機號碼！')
            }else if(!this.email){
                alert('沒有輸入郵箱！')
            }else if(this.phone.length != this.seletedArea.length && !checkEmail.test(this.email)){
                alert('手機號碼格式錯誤 且 郵箱格式錯誤！')
            }else if(this.phone.length != this.seletedArea.length){
                alert('手機號碼格式錯誤！')
            }else if(!checkEmail.test(this.email)){
                alert('郵箱格式錯誤！')
            }else {
                //提交
                // 手机号码：this.phone， 邮箱：this.email， 区号： this.seletedArea.number
                alert('提交成功！')
                this.phone = '';
                this.email = '';
                this.seletedArea = '';
                this.$emit('close')
            }
                
                
        } 
    }
}
</script>
<style scoped lang="scss" src="./scss/order.scss"></style>